import React from 'react';
import { ICON_STROKE } from '../../constants/icon-stroke';

/** Pass / prepaid — perforated ticket stub (20×20 viewBox). Matches admin `apps/web/src/components/CustomIcons/PassesIcon`. */

const PASS_TICKET_PATH_D =
  'M6.66669 6.66659V5.83325M6.66669 10.4166V9.58325M6.66669 14.1666V13.3333M5.66669 16.6666H14.3334C15.7335 16.6666 16.4336 16.6666 16.9683 16.3941C17.4387 16.1544 17.8212 15.772 18.0609 15.3016C18.3334 14.7668 18.3334 14.0667 18.3334 12.6666V7.33325C18.3334 5.93312 18.3334 5.23306 18.0609 4.69828C17.8212 4.22787 17.4387 3.84542 16.9683 3.60574C16.4336 3.33325 15.7335 3.33325 14.3334 3.33325H5.66669C4.26656 3.33325 3.56649 3.33325 3.03171 3.60574C2.56131 3.84542 2.17885 4.22787 1.93917 4.69828C1.66669 5.23306 1.66669 5.93312 1.66669 7.33325V12.6666C1.66669 14.0667 1.66669 14.7668 1.93917 15.3016C2.17885 15.772 2.56131 16.1544 3.03171 16.3941C3.56649 16.6666 4.26656 16.6666 5.66669 16.6666Z';

export interface PassesIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

export const PassesIcon: React.FC<PassesIconProps> = ({
  size = 20,
  color = 'currentColor',
  strokeWidth = ICON_STROKE.standard,
  className,
  style,
  title,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    style={style}
    role={title ? 'img' : 'presentation'}
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d={PASS_TICKET_PATH_D}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
